import React from 'react';
import '../styles/Card.css';
import { generateVCard } from '../utils/vcardGenerator';

const Card = ({ profile }) => {
  const handleDownload = () => {
    generateVCard(profile);
  };

  const getInitials = () => {
    const first = profile.firstName ? profile.firstName.charAt(0) : '';
    const last = profile.lastName ? profile.lastName.charAt(0) : '';
    return (first + last).toUpperCase();
  };
  
  // Déterminer quels réseaux sociaux sont remplis
  const hasSocials = () => {
    if (!profile.socials) return false;
    
    return Object.values(profile.socials).some(value => value && value.trim() !== '');
  };
  
  const socialIcons = {
    linkedin: '📱',
    twitter: '🐦',
    instagram: '📷',
    facebook: '📘',
    youtube: '📺',
    skype: '👥',
    whatsapp: '📱',
    other: '🔗'
  };

  return (
    <div className="card-preview" style={{ '--theme-color': profile.themeColor }}>
      <div className="card-header">
        <div className="card-photo">
          {profile.photoUrl ? (
            <img src={profile.photoUrl} alt={"" + profile.firstName + " " + profile.lastName} />
          ) : (
            <div className="photo-placeholder">
              <div className="photo-icon">{getInitials() || '👤'}</div>
            </div>
          )}
          <div className="card-logo">
            {profile.companyLogo ? (
              <img src={profile.companyLogo} alt={"Logo " + (profile.company || 'entreprise')} />
            ) : (
              <div className="photo-placeholder">
                <div className="photo-icon" style={{ fontSize: '12px' }}>🏢</div>
              </div>
            )}
          </div>
        </div>
        <div className="card-title">
          <h3>{("" + profile.firstName + " " + profile.lastName).trim() || 'Nom Prénom'}</h3>
          <p>{profile.title || 'Poste non spécifié'}</p>
          {profile.company && <p className="company">{profile.company}</p>}
        </div>
      </div>
      
      <div className="card-details">
        {profile.phone && (
          <div className="detail-row">
            <div className="detail-label">Tél :</div>
            <div className="detail-value">{profile.phone}</div>
          </div>
        )}
        
        {profile.email && (
          <div className="detail-row">
            <div className="detail-label">Email :</div>
            <div className="detail-value">{profile.email}</div>
          </div>
        )}
        
        {profile.website && (
          <div className="detail-row">
            <div className="detail-label">Web :</div>
            <div className="detail-value">{profile.website}</div>
          </div>
        )}
        
        {profile.address && (
          <div className="detail-row">
            <div className="detail-label">Adresse :</div>
            <div className="detail-value">{profile.address}</div>
          </div>
        )}
        
        {profile.note && (
          <div className="detail-row">
            <div className="detail-label">Note :</div>
            <div className="detail-value">{profile.note}</div>
          </div>
        )}
      </div>
      
      {hasSocials() && (
        <div className="socials-preview">
          {Object.entries(profile.socials).map(([network, value]) => {
            if (value && value.trim() !== '') {
              return (
                <div key={network} className="social-icon" title={network}>
                  {socialIcons[network] || '🔗'}
                </div>
              );
            }
            return null;
          })}
        </div>
      )}
      
      <div className="download-links">
        <button onClick={handleDownload} className="download-btn">
          Ajouter aux contacts
        </button>
      </div>
    </div>
  );
};

export default Card;
